import Editor from '@monaco-editor/react';

const LANGUAGES: { key: string; label: string; monacoLang: string; defaultStub: string }[] = [
  {
    key: 'python3',
    label: '🐍 Python',
    monacoLang: 'python',
    defaultStub: 'class Solution:\n    def solve(self):\n        pass\n',
  },
  {
    key: 'java',
    label: '☕ Java',
    monacoLang: 'java',
    defaultStub: 'class Solution {\n    public void solve() {\n        // your code here\n    }\n}\n',
  },
  {
    key: 'cpp',
    label: '⚡ C++',
    monacoLang: 'cpp',
    defaultStub: 'class Solution {\npublic:\n    void solve() {\n        // your code here\n    }\n};\n',
  },
];

interface Props {
  starterCode: Record<string, string>;
  onChange: (lang: string, code: string) => void;
}

export function ProblemStarterCodeTab({ starterCode, onChange }: Props) {
  return (
    <div className="grid grid-cols-3 gap-3 p-4">
      {LANGUAGES.map(lang => (
        <div key={lang.key} className="flex flex-col gap-2">
          <div className="text-[12px] font-semibold text-foreground">{lang.label}</div>
          <div className="border rounded-lg overflow-hidden">
            <Editor
              height="280px"
              language={lang.monacoLang}
              value={starterCode[lang.key] ?? lang.defaultStub}
              onChange={val => onChange(lang.key, val ?? '')}
              theme="vs-dark"
              options={{
                fontSize: 12,
                minimap: { enabled: false },
                scrollBeyondLastLine: false,
                lineNumbers: 'on',
                wordWrap: 'on',
                padding: { top: 8, bottom: 8 },
              }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}
